import React from 'react';
import Lottie from 'lottie-react';
import {useAuth} from "../../context/AuthContext";
import facebookAnimation from '../../lotties/facebook.json';
import {useLang} from "../../context/LanguageContext";

const FacebookCard = () => {
    const { hasPaid } = useAuth();
    const { t } = useLang()

    if(hasPaid){
        return (<></>)
    }

    return (
        <a
            href="https://www.facebook.com/share/g/15oGj6A9Cn/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full my-2 bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] flex items-center justify-between p-4 cursor-pointer"
            style={{ minHeight: '50px', maxHeight:'60px' }} // Slightly taller than 50px to fit text & animation
        >

            <div className="flex-shrink-0">
                <Lottie
                    animationData={facebookAnimation}
                    style={{ width: 80, height: 80, marginLeft: -20 }}
                />
            </div>
            <div className="flex items-center flex-col text-white mr-4">
                <span className="text-sm font-extrabold text-[#e67e22] 00font-medium"> {t('txt.facebookGroup')} </span>
                <span className="text-sm font-semibold">

                </span>
            </div>
        </a>
    );
};

export default FacebookCard;